import { render, staticRenderFns } from "./CkEditor.vue?vue&type=template&id=923702b2&scoped=true&"
import script from "./ckeditor.js?vue&type=script&lang=js&"
export * from "./ckeditor.js?vue&type=script&lang=js&"
import style0 from "./CkEditor.vue?vue&type=style&index=0&id=923702b2&prod&lang=scss&"
import style1 from "./ckeditor.scss?vue&type=style&index=1&id=923702b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923702b2",
  null
  
)

export default component.exports